<template>
  <svg
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    fill="none"
    stroke="currentColor"
    :stroke-width="stroke"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path v-for="(d, i) in paths" :key="i" :d="d" />
  </svg>
</template>

<script setup>
import { computed } from 'vue';
import { ICON_PATHS } from '../lib/icons';

const props = defineProps({
  name: { type: String, required: true },
  size: { type: Number, default: 24 },
  stroke: { type: Number, default: 1.5 }
});

const paths = computed(() => (ICON_PATHS[props.name] || '').split('|'));
</script>
